import type { Dimension } from 'src/types';

export interface CreateKonvaImageParams extends Dimension {
  imgBlob?: Blob | null;
  imgUrl?: string;
  onLoad?: () => void;
}

export const createKonvaImageFn = ({ width, height, imgBlob, imgUrl, onLoad }: CreateKonvaImageParams) => {
  const img = new window.Image();
  img.crossOrigin = 'Anonymous';
  img.width = width;
  img.height = height;

  if (typeof onLoad === 'function') {
    img.onload = onLoad;
  }
  let objectUrl: string | null = null;

  if (imgBlob) {
    objectUrl = URL.createObjectURL(imgBlob);
    img.src = objectUrl;
  } else {
    img.src = imgUrl || '';
  }

  return {
    img,
    objectUrl,
  };
};
